import React from "react";
import DOMPurify from 'dompurify';

const CondPayment = ({props}) => {    
    if(!props?.webContentHtmlPa || props?.webContentHtmlPa === "" || props?.webContentHtmlPa.status) {
        return null;
    } 

    return (
        <div dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                    props?.webContentHtmlPa,
                    {USE_PROFILES: {html: true}}
                ),
            }}          
        ></div>
    );
};

export default CondPayment;